import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/coupon/list'
    return request.post(url,data)
}

export function all() {
    let url = '/coupon/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/coupon/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/coupon/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/coupon/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/coupon/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/coupon/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/coupon/dmz/options'
    return request.get(url)
}

export function upload(file) {
    let url = '/coupon/upload';
    let forms = new FormData()
    forms.append("file",file)
    let config = {
        headers:{'Content-Type':'multipart/form-data'}
    }; //
    return request.post(url,forms,config)
}